"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const IInaxConfigService_interface_1 = require("../../../common/src/interfaces/IInaxConfigService.interface");
let InaxConfigComponent = class InaxConfigComponent {
    constructor(_configurationService) {
        this._configurationService = _configurationService;
    }
    ngOnInit() {
        this._configurationService.getConfiguration().subscribe((configSettings) => {
            this._savedSettings = configSettings;
            this._enabledHubs = this._savedSettings.SignalRHubs.map((hub) => {
                return configSettings.EnabledSignalRHubs.find((enabledhub) => enabledhub === hub) !== undefined;
            });
            this.url = configSettings.Url;
            this.username = configSettings.Username;
            this.password = configSettings.Password;
            this.defaultLanguage = configSettings.DefaultLanguage;
            this.useSignalR = configSettings.UseSignalR;
        });
    }
    apply() {
        this._configurationService.setConfiguration({
            Url: this.url,
            Username: this.username,
            Password: this.password,
            DefaultLanguage: this.defaultLanguage,
            UseSignalR: this.useSignalR,
            SignalRHubs: this._savedSettings.SignalRHubs,
            EnabledSignalRHubs: this._savedSettings.SignalRHubs.filter((hub, index) => { return this._enabledHubs[index]; })
        });
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InaxConfigComponent.prototype, "url", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InaxConfigComponent.prototype, "username", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InaxConfigComponent.prototype, "password", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], InaxConfigComponent.prototype, "defaultLanguage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], InaxConfigComponent.prototype, "useSignalR", void 0);
InaxConfigComponent = __decorate([
    core_1.Component({
        selector: 'inax-config',
        templateUrl: './@inax/inaxConfigUi/src/components/inaxConfig.component.html',
        styleUrls: ['./@inax/inaxConfigUi/src/components/inaxConfig.component.css']
    }),
    __param(0, core_1.Inject(IInaxConfigService_interface_1.IINAXCONFIGSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object])
], InaxConfigComponent);
exports.InaxConfigComponent = InaxConfigComponent;
